<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户信息的主键id">
              <a-input placeholder="请输入用户信息的主键id" v-model="queryParam.userKeyId"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户id')">
              <a-input :placeholder="$t('请输入用户id')" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.userMeterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('上期读数')">
              <a-input :placeholder="$t('请输入用户上期读数')" v-model="queryParam.userMeterPreNum"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('上期抄表时间')">
                <j-date :placeholder="$t('请选择上期抄表时间')" v-model="queryParam.userMeterPreDatetime"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('本期抄表读数')">
                <a-input :placeholder="$t('请输入本期抄表读数')" v-model="queryParam.userMeterNowNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('本期抄表时间')">
                <j-date :placeholder="$t('请选择本期抄表时间')" v-model="queryParam.userMeterNowDatetime"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('本期用量')">
                <a-input :placeholder="$t('请输入用户本期用量')" v-model="queryParam.userMeterUseFlow"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户账单Id')">
                <a-input :placeholder="$t('请输入用户账单Id')" v-model="queryParam.userBillId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('账单金额')">
                <a-input :placeholder="$t('请输入用户账单金额')" v-model="queryParam.userBillNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('账单日期')">
                <j-date :placeholder="$t('请选择账单日期')" v-model="queryParam.userBillDate"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('账单是否结账')">
                <a-input :placeholder="$t('请输入账单是否结账 0 未结账 1已结账')" v-model="queryParam.userBillIsEnd"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>

      </a-table>
    </div>

    <meter-user-bill-list-modal ref="modalForm" @ok="modalFormOk"></meter-user-bill-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterUserBillListModal from './modules/MeterUserBillListModal'
  import JDate from '@/components/jeecg/JDate.vue'

  export default {
    name: 'MeterUserBillListList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDate,
      MeterUserBillListModal
    },
    data () {
      return {
        description: 'meter_user_bill_list管理页面',
        url: {
          list: "/jeecg-charge/meter/meterUserBillList/list",
          delete: "/jeecg-charge/meter/meterUserBillList/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserBillList/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserBillList/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserBillList/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户名'),
            align:"center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'userMeterId'
          },
          {
            title: this.$t('上期读数'),
            align:"center",
            dataIndex: 'userMeterPreNum'
          },
          {
            title: this.$t('上期抄表时间'),
            align:"center",
            dataIndex: 'userMeterPreDatetime'
          },
          {
            title: this.$t('本期抄表读数'),
            align:"center",
            dataIndex: 'userMeterNowNum'
          },
          {
            title: this.$t('本期抄表时间'),
            align:"center",
            dataIndex: 'userMeterNowDatetime'
          },
          {
            title: this.$t('本期用量'),
            align:"center",
            dataIndex: 'userMeterUseFlow'
          },
          {
            title: this.$t('用户账单Id'),
            align:"center",
            dataIndex: 'userBillId'
          },
          {
            title: this.$t('账单金额'),
            align:"center",
            dataIndex: 'userBillNum'
          },
          {
            title: this.$t('账单日期'),
            align:"center",
            dataIndex: 'userBillDate',
          },
          {
            title: this.$t('账单是否结账'),
            align:"center",
            dataIndex: 'userBillIsEnd'
          },

          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('创建操作员'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
</style>